//const BASE_URL = "http://localhost:5001";
const BASE_URL = "https://api.face4id.com";
export { BASE_URL };
